import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import { Alert, AlertColor, Backdrop, Slide, SlideProps, Snackbar } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { ZoomMtg } from '@zoom/meetingsdk';
import axios from 'axios';
import React from 'react';
import { connect, useSelector } from "react-redux";
import AxiosRequest from '../components/helpers/AxiosRequest';
import Helpers from '../components/helpers/Helpers';
import i18n from '../i18n';
import { ApplicationState } from '../store';
import * as AppDataStore from '../store/AppData';
import Layout from './Layout';
import { store } from '..';
import * as ModalStore from '../store/Modal';
import { useNavigate } from "react-router-dom";
import './loaderStyle.css';
import ZoomAuthErrorDialog from './common/ZoomAuthErrorDialog';

/*ZoomMtg.setZoomJSLib("https://source.zoom.us/2.13.0/lib", "/av");*/
ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();
ZoomMtg.i18n.load("en-US");
ZoomMtg.i18n.reload("en-US");

const oauthUrl = window.location.hostname === "localhost" ?
    "https://zoom.us/oauth/authorize?client_id=osATVr_rQ4qEn2ogdlwoGA&response_type=code&redirect_uri=https%3A%2F%2Flocalhost%3A44403%2Fapi%2Fzoom%2Fauth" :
    "https://zoom.us/oauth/authorize?response_type=code&client_id=h07umaAT566ex3aFNUFuJGPjhq0XtJATPXWt&redirect_uri=https://zoom.lexzur.com/api/zoom/auth";
let app4LegalDataCurrent: any = null;

const Home = (props: any) => {
    let oAuthWindow: any;
    let zoomMeetingData: any = null;
    const [loading, setLoading] = React.useState(false);
    let authStarted = false;
    const tokens = useSelector((state: ApplicationState) => state.appData?.tokens);
    const [meetingStarted, setMeetingStarted] = React.useState(false);
    const [createMeetingsLimit, setCreateMeetingLimit] = React.useState(false);
    const [createMeetingsLimitMessage, setCreateMeetingLimitMessage] = React.useState("");
    const [openAlert, setOpenAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [severity, setSeverity] = React.useState<AlertColor | undefined>("error");
    const [errorContent, setErrorContent] = React.useState("");
    const [open, setOpen] = React.useState(false);
    let signatureEndpoint = "api/zoom/sign";
    let meetingNumber = '';
    let role = 1;
    let leaveUrl = window.location.origin + '/end';
    let userName: any = null;
    let userEmail: any = null;
    let passWord: any = null;
    let getZakToken = '';
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    const authCheck = useSelector((state: ApplicationState) => state.appData?.check_zoom_auth);
    i18n.changeLanguage(appLanguage);
    const navigate = useNavigate();

    const setZoomAuthData = async (event: any) => {
        try {
            //  Ensure app4legalData is not empty before calling getZoomTokens
            if (!event || !event["api-base-url"]) {
                console.log(" app4legalData is missing required fields. Skipping Zoom auth.");
                return;
            }

            console.log(" Fetching Zoom tokens...");
            let responseGetTokens = await Helpers.getZoomTokens(event);

            if (responseGetTokens?.data?.error?.msg === "") {
                const zoomTokens = responseGetTokens?.data?.success?.data?.zoom?.tokens;
                if (zoomTokens) {
                    console.log(" Tokens received, setting them...");
                    props.fillTokens(zoomTokens);
                } else {
                    console.log(" No tokens found in response!");
                }
            } else {
                console.log(" Error in response: ", responseGetTokens?.data?.error?.msg);
            }
            props.setCheckZoomAuth(true);
        } catch (e) {
            console.log(" Error in setZoomAuthData: ", e);
            props.setCheckZoomAuth(true);
        }
    };

    React.useEffect(() => {
        window.addEventListener("handleCallBackAuthZoom", handleCallBackAuthZoom);

        console.log(" Sending postMessage to opener...");
        window.opener?.postMessage({ payload: { app4legal_zoom: true } }, "*");

        if (window.location.hostname === "localhost") {
            console.log(" Running on localhost...");
            props.setCheckZoomAuth(false);

            let app4legalZoom = {
                "x-api-key": "",
                "api-base-url": "",
                "installationType": "",
                "userId": "",
                "profileName": "",
                "email": "",
                "module": null,
                "moduleRecordId": null,
                "moduleRecordName": "",
                "lang": "en",
            };

            if (!app4legalZoom["lang"]) {
                app4legalZoom["lang"] = "en";
            }
            localStorage.setItem("lang", app4legalZoom["lang"]);

            app4LegalDataCurrent = app4legalZoom;
            props.fillApp4legalData(app4legalZoom);

            //  Only call setZoomAuthData if app4legalData is valid
            if (app4legalZoom["api-base-url"]) {
                setZoomAuthData(app4legalZoom);
            } else {
                console.log(" Skipping Zoom authentication due to missing API Base URL.");
            }
        } else {
            props.setCheckZoomAuth(false);

            window.addEventListener("message", (event) => {
                try {
                    //console.log(" Received Message: ", event.data);

                    if (event.data && event.data.payload) {
                        let payLoad = event.data.payload;
                        if (payLoad["app4legal_zoom"]) {
                            let app4legalZoom = payLoad["app4legal_zoom"];

                            if (!app4legalZoom["lang"]) {
                                app4legalZoom["lang"] = "en";
                            }
                            localStorage.setItem("lang", app4legalZoom["lang"]);

                            if (!app4LegalDataCurrent) {
                                app4LegalDataCurrent = app4legalZoom;
                                props.fillApp4legalData(app4legalZoom);
                            }
                            props.fillApp4legalData(app4legalZoom);

                            //  Ensure we only proceed if API base URL is available
                            if (app4LegalDataCurrent["api-base-url"] ? app4LegalDataCurrent["api-base-url"]:app4legalZoom["api-base-url]"]) {
                                setZoomAuthData(app4LegalDataCurrent["api-base-url"] ? app4LegalDataCurrent:app4legalZoom);
                            } else {
                                console.log(" Skipping Zoom authentication due to missing API Base URL.");
                            }
                        }
                    } else {
                        console.log(" Received an empty or malformed message.");
                    }
                } catch (e: any) {
                    console.log(" Error processing message event: ", e.message);
                }
            });
        }

        window.opener?.postMessage({ payload: { app4legal_zoom: true } }, "*");

        return () => {
            window.removeEventListener("handleCallBackAuthZoom", handleCallBackAuthZoom);
            window.removeEventListener("message", handleCallBackAuthZoom);
        };
    }, []);

    React.useEffect(() => {
        let canMeetingStart = null;
        if (authCheck == true) {
            if ((tokens) && props.app4legalData) {
                canMeetingStart = true;
            } else {
                canMeetingStart = false;
            }
        }
        //----------------------------
        if (canMeetingStart === true) {
            startZoomMeeting();
        } else if (canMeetingStart === false) {
            startOAuth();
        }
    }, [tokens, authCheck, props.app4legalData]);

    React.useEffect(() => {
        // console.log("React.useEffect");
        // console.log(props.app4legalData);
        if (props.app4legalData != null) {
            let apiKey = props.app4legalData["x-api-key"]!;
            let curentUserData = props.app4legalData;
            if (props?.app4legalData["api-base-url"]!) {
                (async () => {
                    const header = {
                        "x-api-key": apiKey,
                        "Content-type": "application/json; charset=utf-8",
                        "x-api-channel": "mobile"
                    };

                    if (curentUserData.module == "matter") {
                        // console.log(curentUserData["api-base-url"])
                        let response = await axios({
                            // url: curentUserData["api-base-url"] + "modules/api/cases/edit/" + curentUserData.moduleRecordId,
                            url: curentUserData["api-base-url"] + "modules/api/cases/get_related_people/" + curentUserData.moduleRecordId,
                            method: 'GET',
                            headers: header
                        });
                        if (response.data.error == "") {
                            // console.log(response);
                            const defaultValues = response.data.success.data.contacts;
                            const defaultCompanies = response.data.success.data.companies;
                            if (defaultValues?.length > 0 || defaultCompanies?.length > 0) {
                                let listOfUsers: any[] = [];
                                if (defaultValues?.length > 0) {
                                    for (var i = 0; i < defaultValues?.length; i++) {
                                        let email = defaultValues[i].email;
                                        let name = defaultValues[i].fullName;
                                        let userId = defaultValues[i].id;
                                        if (!listOfUsers.find(element => element.email == email))
                                            listOfUsers.push({ email: email, fullName: name, id: userId, type: defaultValues[i].label ?? defaultValues[i].type });
                                    }
                                }
                                if (defaultCompanies?.length > 0) {
                                    for (var i = 0; i < defaultCompanies?.length; i++) {
                                        let email = defaultCompanies[i].email;
                                        let name = defaultCompanies[i].name;
                                        let userId = defaultCompanies[i].id;
                                        if (!listOfUsers.find(element => element.email == email))
                                            listOfUsers.push({ email: email, fullName: name, id: userId, type: defaultCompanies[i].label ?? defaultCompanies[i].type });
                                    }
                                }
                                let matterData = {
                                    InviteesList: listOfUsers
                                }
                                //console.log(listOfUsers);
                                props.fillMatetrData(matterData);
                            }
                            else {
                                let listOfUsers: any[] = [];
                                let Data = {
                                    InviteesList: listOfUsers
                                }

                                props.fillMatetrData(Data);
                            }
                        }
                        else {
                            let listOfUsers: string[] = [];
                            let Data = {
                                InviteesList: listOfUsers
                            }

                            props.fillMatetrData(Data);
                            Helpers.saveLogs(response.data.error);
                            setSeverity("error");
                            setErrorContent(JSON?.stringify(response.data.error));
                            setErrorAlert(true);
                        }
                    }
                    else if (curentUserData.module == "contract") {
                        let response = await axios({
                            url: curentUserData["api-base-url"] + "modules/api/contracts/get_related_people/" + curentUserData.moduleRecordId,
                            method: 'GET',
                            headers: header
                        });
                        if (response.data.error == "") {
                            const defaultValues = response.data.success.data.contacts;
                            const defaultCompanies = response.data.success.data.companies;
                            if (defaultValues?.length > 0 || defaultCompanies?.length > 0) {
                                let listOfUsers: any[] = [];
                                if (defaultValues?.length > 0) {
                                    for (var i = 0; i < defaultValues?.length; i++) {
                                        let email = defaultValues[i].email;
                                        let name = defaultValues[i].fullName;
                                        let userId = defaultValues[i].id;
                                        if (!listOfUsers.find(element => element.email == email))
                                            listOfUsers.push({ email: email, fullName: name, id: userId, type: defaultValues[i].label ?? defaultValues[i].type });
                                    }
                                }
                                if (defaultCompanies?.length > 0) {
                                    for (var i = 0; i < defaultCompanies?.length; i++) {
                                        let email = defaultCompanies[i].email;
                                        let name = defaultCompanies[i].name;
                                        let userId = defaultCompanies[i].id;
                                        if (!listOfUsers.find(element => element.email == email))
                                            listOfUsers.push({ email: email, fullName: name, id: userId, type: defaultCompanies[i].label ?? defaultCompanies[i].type });
                                    }
                                }
                                let contractData = {
                                    InviteesList: listOfUsers
                                }
                                props.fillContractData(contractData);
                            }
                        }
                        else {
                            let listOfUsers: any[] = [];
                            let Data = {
                                InviteesList: listOfUsers
                            }
                            props.fillContractData(Data);
                            Helpers.saveLogs(response.data.error);
                            setSeverity("error");
                            setErrorContent(JSON?.stringify(response.data.error));
                            setErrorAlert(true);
                        }
                    }
                    else {
                        let response = await axios({
                            url: curentUserData["api-base-url"] + "modules/api/auth_users/autocomplete",
                            method: 'GET',
                            headers: header
                        });
                        //console.log(response);
                        if (response.data.error == "") {
                            const defaultValues = response.data.success.data;
                            const defaultCompanies = response.data.success.data.companies;
                            if (defaultValues && defaultValues.length > 0) {
                                let listOfUsers = [];
                                for (var i = 0; i < defaultValues.length; i++) {
                                    let email = defaultValues[i].email;
                                    let name = defaultValues[i].firstName + " " + defaultValues[i].lastName;
                                    let userId = defaultValues[i].id;
                                    listOfUsers.push({ email: email, fullName: name, id: userId });
                                }
                                if (defaultCompanies?.length > 0) {
                                    for (var i = 0; i < defaultCompanies?.length; i++) {
                                        let email = defaultCompanies[i].email;
                                        let name = defaultCompanies[i].name;
                                        let userId = defaultCompanies[i].id;
                                        listOfUsers.push({ email: email, fullName: name, id: userId });
                                    }
                                }
                                let Data = {
                                    InviteesList: listOfUsers
                                }
                                //console.log(Data);
                                props.fillContractData(Data);
                            }
                            else {
                                let listOfUsers: string[] = [];
                                let Data = {
                                    InviteesList: listOfUsers
                                }
                                props.fillContractData(Data);
                            }
                        }
                        else {
                            let listOfUsers: string[] = [];
                            let Data = {
                                InviteesList: listOfUsers
                            }
                            props.fillContractData(Data);
                            Helpers.saveLogs(response.data.error);
                            setSeverity("error");
                            setErrorContent(JSON?.stringify(response.data.error));
                            setErrorAlert(true);
                        }
                    }
                })();
            }
        }
    }, [props?.app4legalData?.moduleRecordId]);
    const createNewMeeting = async () => {
        // console.log("zoom_access_token");
        //console.log(userEmail);
        var dataToPost = {
            "topic": props.app4legalData["moduleRecordName"] ?? "App4Legal Zoom meeting", //moduleRecordName
            "agenda": props.app4legalData["moduleRecordName"] ?? "App4Legal Zoom meeting", //moduleRecordName
            "title": props.app4legalData["moduleRecordName"] ?? "App4Legal Zoom meeting", //moduleRecordName
            "duration": 60,
            "pre_schedule": false,
            //"timezone": timeZone,
            //"start_time": date,
            "schedule_for": userEmail,
            "settings": {
                "host_video": false,
                "mute_upon_entry": false,
                "participant_video": false,
                "registrants_confirmation_email": "true"
            }
        }
        const Header = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': tokens /*accessToken*/
            }
        };
        let response: any = await AxiosRequest.post("api/zoom/create/meeting", dataToPost, Header).catch((error) => {
            const zoomError = error.response?.data;

            if (zoomError?.code === 403 &&
                zoomError?.message?.includes("not permitted access")) {
                setSeverity("warning");
                setErrorContent("error");
                setErrorAlert(true);
            } else {
                Helpers.saveLogs(zoomError?.errors);
                setSeverity("error");
                setErrorContent(JSON?.stringify(zoomError?.errors));
                setErrorAlert(true);
            }
        });
        //  console.log("Create Zoom Meeting - Response::");
        //  console.log(response)
        if (response?.status === 200) {
            // console.log("Create Zoom Meeting - Error::");
            // console.log(response.data.code);
            if (response.data.code === 429) {
                setCreateMeetingLimit(true);
                navigate("error");
                setCreateMeetingLimitMessage(response.data.message);
                store.dispatch(ModalStore.actionCreators.openModalError(i18n.t('app.limitAlertMessage')));
            }
            if (response.data.code === 403) {
                if (response.data?.message?.includes("not permitted access")) {
                    setOpen(true);
                }
            }
            if (response.data.code === 124) {
                startOAuth();
                return null;
            } else if (response.data.errors) {
                //show alert error
                Helpers.saveLogs(response);
                setSeverity("error");
                setErrorContent(JSON?.stringify(response.data.errors));
                setErrorAlert(true);

                return null;
            } else {
                zoomMeetingData = response.data;
                meetingNumber = response.data.id;
                passWord = response.data.password;
                return true;
            }
        } else {
            //show alert error
            Helpers.saveLogs(response);
            setSeverity("error");
            setErrorContent(JSON?.stringify(response));
            setErrorAlert(true);
        }
    };
    const startZoomMeeting = async () => {
        // console.log(accessToken);
        /*if (accessToken) {*/
        if (tokens) {
            await getUserInfo();
            //let liveMeeting = await getLiveMeeting();
            //if (!liveMeeting) {
            //    await createNewMeeting();
            //}
            await createNewMeeting();
            getZakToken = await generateZakToken();
            await getSignature();
        } else {
            //startOAuth();
        }
    };
    const generateZakToken = async () => {
        if (tokens) {
            const Header = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': tokens /*accessToken*/
                }
            };
            const response = await AxiosRequest.get("api/zoom/meeting/zak", Header);
            return response.data;
        }
    };
    const getUserInfo = async () => {
        if (userName !== null && userEmail !== null) {

        } else {
            /* if (accessToken) {*/
            if (tokens) {
                const Header = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': tokens /*accessToken*/
                    }
                };
                const response = await AxiosRequest.get("api/zoom/user/me", Header);
                userName = response.data.first_name + " " + response.data.last_name;
                userEmail = response.data.email;
            }
        }
    }
    const getSignature = async () => {
        /* if (accessToken) {*/
        if (tokens) {
            //------------old signature---------------------------
            let response = await axios.post(signatureEndpoint,
                {
                    "meetingNumber": meetingNumber,
                    "role": role
                }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).catch(error => {
                setLoading(false);
            });
            //Fill meeting Data
            props.fillZoomMeetingData(zoomMeetingData);
            startMeeting(response?.data?.signature);
            //console.log("signature");
            // console.log(response?.data?.signature);
        }
    }
    const startOAuth = () => {
        setOpenAlert(true);
        // console.log("Start Oauth");
        if (authStarted === false) {
            authStarted = true;
            oAuthWindow = window.open(oauthUrl, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=500,width=500,height=600");

        }
    }
    const handleCallBackAuthZoom = async (e: any) => {
        try {
            if (!e.detail.tokens) {
                console.warn("No tokens in event detail.");
                return;
            }

            //console.log(" Tokens received:", e.detail.tokens);
            //console.log(" Current app4legalData:", props.app4legalData);
            //console.log(" Current app4LegalDataCurrent:", app4LegalDataCurrent);

            const apiData = app4LegalDataCurrent["api-base-url"] ?? props.app4legalData["api-base-url"];

            if (!apiData) {
                console.error(" API Base URL is missing. Cannot set tokens.");
                return;
            }

            let response = await Helpers.setZoomTokens(apiData, e.detail.tokens);
            //console.log(" Token response:", response);

            props.fillTokens(e.detail.tokens);
            oAuthWindow?.close();
            startZoomMeeting();
        } catch (error) {
            console.error(" Error in handleCallBackAuthZoom:", error);
        }
    };

    function startMeeting(signature: any) {
        let docRootZoomMeeting = document?.getElementById('zmmtg-root')! as any;
        docRootZoomMeeting.style.display = 'block';
        ZoomMtg.init({
            leaveUrl: leaveUrl,
            // disablePreview: false,
            success: (success: any) => {
                ZoomMtg.join({
                    signature: signature,
                    sdkKey: 'h07umaAT566ex3aFNUFuJGPjhq0XtJATPXWt',
                    meetingNumber: meetingNumber,
                    passWord: passWord,
                    userName: userName,
                    userEmail: userEmail,
                    zak: getZakToken,
                    success: (success: any) => {
                        console.log(success)
                    },
                    error: (error: any) => {
                        Helpers.saveLogs(error);
                        setSeverity("error");
                        setErrorContent(JSON?.stringify(error));
                        setErrorAlert(true);
                        console.log(error);
                    }
                })
            },
            error: (error: any) => {
                console.log(error);
            }
        })
        return;
    };
    function SlideTransition(props: SlideProps) {
        return <Slide {...props} direction="down" />;
    };

    return (<>
        {createMeetingsLimit ? <></> :
            <Layout>
                <ZoomAuthErrorDialog open={open} token={tokens} setOpen={setOpen} oauthUrl={oauthUrl} />
                {/*accessToken*/ tokens ? <>
                    <Snackbar
                        open={errorAlert}
                        autoHideDuration={4000}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        TransitionComponent={SlideTransition}
                    >

                        <Alert severity={severity}>{errorContent} </Alert>
                    </Snackbar>
                    <div className="App">
                        <div id="meetingSDKElement"></div>
                        {meetingStarted === false ?
                            null
                            : <main>
                                <Stack sx={{ display: "none" }} spacing={3} direction="row">
                                    <Button variant="outlined" disabled={loading} style={{ marginRight: "15px", paddingLeft: "25px" }} startIcon={<VideocamOutlinedIcon />} onClick={startZoomMeeting}>
                                        {i18n.t('app.join')}
                                    </Button>
                                </Stack>
                            </main>
                        }
                    </div>
                </>
                    :
                    <>
                        <Snackbar
                            open={openAlert}
                            autoHideDuration={4000}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }}
                            TransitionComponent={SlideTransition}
                        >

                            <Alert severity="info">{i18n.t('app.makeSureToAllowPopups')}</Alert>
                        </Snackbar>
                        <Backdrop open={true}>
                            <div className="lds-ripple"><div></div><div></div></div>
                        </Backdrop>
                    </>
                }
            </Layout>}
    </>
    );
};

const mapStateToProps = (state: any) => ({
    allData: state,
    app4legalData: state.appData.app4legalData
});

export default connect(mapStateToProps, { ...AppDataStore.actionCreators })(Home);
